/*
 * Organizer > Camp: table columns shared by the dashboard (check-ins).
 * Rows come from GET /org/camp/stay/dashboard (same shape as Support > Dashboard > Camp).
 */
export const day = (val) => (val ? new Date(val).toLocaleDateString('en-IN') : 'N/A');
const muted = { fontSize: 12, color: '#6b7280' };

export const checkInColumns = [
    {
        label: 'Stay',
        accessor: 'listingName',
        render: (val, row) => (
            <div>
                <strong>{val || 'N/A'}</strong>
                {row.place && <div style={muted}>{row.place}</div>}
            </div>
        )
    },
    {
        label: 'Guest',
        accessor: 'guestName',
        render: (val, row) => (
            <div>
                {val || 'N/A'}
                {row.phoneNumber && <div style={muted}>{row.phoneNumber}</div>}
            </div>
        )
    },
    { label: 'Check-in', accessor: 'checkIn', render: day },
    { label: 'Check-out', accessor: 'checkOut', render: (val, row) => `${day(val)} (${row.nights || 0}N)` },
    { label: 'Rooms', accessor: 'rooms', render: (val) => val || '-' },
    {
        label: 'Guests',
        accessor: 'adults',
        render: (val, row) =>
            [
                `${val || 0} adult${val === 1 ? '' : 's'}`,
                row.children ? `${row.children} child` : '',
                row.pets ? `${row.pets} pet` : ''
            ]
                .filter(Boolean)
                .join(', ')
    },
    {
        label: 'Paid',
        accessor: 'paid',
        render: (val, row) => (
            <div>
                ₹{val || 0}
                {row.isReserved && (
                    <div style={{ ...muted, color: '#dc2626' }}>
                        ₹{Math.max((row.total || 0) - (val || 0), 0)} at the stay
                    </div>
                )}
            </div>
        )
    },
    { label: 'Via', accessor: 'bookedVia', render: (val) => val || '-' },
    {
        label: 'Status',
        accessor: 'status',
        render: (val) => (
            <span style={val === 'Cancelled' ? { color: '#dc2626', fontWeight: 600 } : undefined}>{val}</span>
        )
    }
];
